import { palette } from '../global/palette';
import { typography } from '../global/typography';
import type { ComponentOverride } from '../types';

export const MuiSlider: ComponentOverride<'MuiSlider'> = {
  MuiSlider: {
    styleOverrides: {
      root: {
        display: 'flex',
      },
      mark: {
        opacity: 1,
        width: '2px',
        height: '8px',
        backgroundColor: palette.grey[300],
      },
      markActive: {
        backgroundColor: palette.primary.main,
      },
      rail: {
        backgroundColor: palette.grey[300],
      },
      thumb: {
        backgroundColor: palette.common.white,
        border: '3px solid currentColor',
        height: 20,
        width: 20,
        //1A is 0.1 opacity in hexa
        '&:hover': {
          boxShadow: `0px 0px 0px 8px ${palette.primary.main}1A`,
        },
        '&:active': {
          boxShadow: `0px 0px 0px 14px ${palette.primary.main}1A`,
        },
      },
      valueLabel: {
        ...typography.h5,
        fontSize: 11,
        backgroundColor: 'transparent',
        '& > *': {
          display: 'flex',
          justifyContent: 'center',
          backgroundColor: palette.grey[800],
          width: 24,
          height: 24,
          borderRadius: '50% 50% 50% 0',
          transform: 'rotate(-45deg)',
          '& > *': {
            position: 'absolute',
            top: '20%',
            transform: 'rotate(45deg)',
          },
        },
      },
    },
    defaultProps: {
      valueLabelDisplay: 'auto',
    },
  },
};
